export default {"src":"/_next/static/media/podCafeIcon.262f28b7.svg","height":17,"width":15};